import React from 'react';
import {
  Container, Row, Col, Image,
} from 'react-bootstrap';
import Contacto from '../components/Contacto';
import Geolocation from '../components/Geolocation';
import Agendar from '../components/Agendar';
import Playa from '../assets/playa.jpg';

function Contact() {
  return (
    <Container fluid>
      <h1 className="text-center mt-5">CONTÁCTENOS</h1>
      <hr className="divider" />
      <Row>
        <Col className="contact image-home" sm md lg xl xxl xxxl>
          <Image
            src={Playa}
            style={{ width: '100%', height: '49vh' }}
            fluid
          />
          <Contacto />
          <Geolocation />
          <Agendar />
        </Col>
      </Row>
    </Container>
  );
}

export default Contact;
